export default "__VITE_ASSET__DGaUR_QW__"